import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_TEMPLATES_TABLE_DATA } from "./query";
import { ChartContainer } from "../../../Components/Chart/styles";
import DataTable from "react-data-table-component";
import useDefaultTableStyles from "../../../Components/MsgBoxTable/use-default-table-styles";

const TemplatesTable = ({ start, end, inboxes }) => {
	const [formattedData, setFormattedData] = useState([]);
	const { data, error, loading } = useQuery(GET_TEMPLATES_TABLE_DATA, {
		variables: {
			start,
			end,
			inboxes,
		},
		fetchPolicy: "no-cache",
	});
	const defaultTableStyles = useDefaultTableStyles();

	useEffect(() => {
		if (data && data.msgbox_BroadcastContact && data.msgbox_BroadcastContact.length > 0) {
			const returnArray = [];
			data.msgbox_BroadcastContact.map((message) => {
				if (message.User) {
					const index = returnArray.findIndex(
						(x) => x.userId === message.User.UserId
					);
					if (index >= 0) {
						returnArray[index].count = returnArray[index].count + 1;
					} else {
						returnArray.push({
							userId: message.User.UserId,
							firstName: message.User.FirstName,
							lastName: message.User.LastName,
							count: 1,
						});
					}
				}
			});
			setFormattedData(returnArray);
		} else {
			setFormattedData([]);
		}
	}, [data]);

	if (error) return null;

	if (loading) return null;

	const columns = [
		{
			name: "First Name",
			selector: "firstName",
		},
		{
			name: "Last Name",
			selector: (row) => row.lastName,
		},

		{
			name: "Templates sent",
			selector: "count",
		},
	];

	return (
		<ChartContainer>
			<DataTable
				customStyles={defaultTableStyles}
				data={formattedData}
				columns={columns}
				title="Templates sent by User"
			/>
		</ChartContainer>
	);
};

export default TemplatesTable;
